import useTranslations from '../../../../hooks/useTranslations'
import ANTDButton from '../../../../shared/antd/ANTDButton'
import ANTDDivider from '../../../../shared/antd/ANTDDivider'
import ANTDInput from '../../../../shared/antd/ANTDInput'
import ANTDSelect from '../../../../shared/antd/ANTDSelect'
import ANTDSpin from '../../../../shared/antd/ANTDSpin'
import { include } from '../../../../utils/javascript'
import equipmentSelect from '../../container/equipmentSelect.container'

const EquipmentSelect = ({ index = 0, disabled }) => {
  const { t } = useTranslations()

  const {
    isOpen,
    search,
    selectedValue,
    options,
    modifyForOptions,
    onInputSearch,
    onScroll,
    handleOnChange,
    handleAddNewItem,
    onDropdownVisible,
  } = equipmentSelect({ index })
  const { list, loader } = { ...options }

  return (
    <ANTDSelect
      loading={loader}
      open={isOpen}
      disabled={disabled}
      filterOption={false}
      value={selectedValue && [selectedValue]}
      options={modifyForOptions(list)}
      onChange={handleOnChange}
      onPopupScroll={onScroll}
      onDropdownVisibleChange={onDropdownVisible}
      dropdownRender={menu => (
        <>
          <div
            style={{
              padding: '5px 4px',
            }}
            className="d-flex"
          >
            <ANTDInput
              style={{ marginRight: '8px' }}
              placeholder={t('txt_SearchESN')}
              value={search}
              onChange={onInputSearch}
              onKeyDown={e => e.stopPropagation()}
            />

            <ANTDButton
              type="primary"
              disabled={
                !search?.trim() ||
                include(
                  list?.map(({ name }) => name),
                  search,
                )
              }
              onClick={handleAddNewItem}
            >{`${t('btn_Add')} +`}</ANTDButton>
          </div>
          <ANTDDivider
            style={{
              margin: '8px 0',
            }}
          />
          {menu}
          {loader && <ANTDSpin size="small" style={{ paddingLeft: 10 }} />}
        </>
      )}
    />
  )
}

export default EquipmentSelect
